const gettingStartedConstants = {
  GET_GETTING_STARTED_REQUEST: 'GET_GETTING_STARTED_REQUEST',
  GET_GETTING_STARTED_SUCCESS: 'GET_GETTING_STARTED_SUCCESS',
  GET_GETTING_STARTED_ERROR: 'GET_GETTING_STARTED_ERROR',
};

export default gettingStartedConstants;
